import { useParams } from "react-router";
import Loader from "../Components/Loader";
import { jwtVerify } from "jose";
import { useState, useEffect, useContext } from "react";
import GeneralContext from "../utils/generalContext";
import { logginIn } from "./login_util";
import axios from "axios";

const LogSubmit = () => {
    const { token } = useParams();
    const { user, destroySession, global } = useContext(GeneralContext);

    const [payload, setPayload] = useState(null);

    useEffect(() => {
      if(user?.user){
        destroySession();
      }
    }, [user])
   
    useEffect(() => {
        const secret = new TextEncoder().encode(process.env.REACT_APP_CURSOS_SECRET_KEY);
        
        async function verifyToken() {
            try {
                const { payload: JWTPayload } = await jwtVerify(token, secret);
                setPayload(JWTPayload); // store payload in state
            } catch (err) {
                console.error(err);
            }
        }

        verifyToken();
    }, [token]);

    useEffect(() => {
        if(payload && payload.data && payload.data.matricula_academica && user && global) {
            const submit = async () => { 
                let url = `${global.domain}v3-api/v3/login_direct.json`;
                console.log({url})
                let res = await axios.post(url, {
                    username: payload.data.matricula_academica,
                    password: payload.data.token
                }).catch(function (error) {
                    console.error(error.message)
                });
        
                localStorage.setItem('user', JSON.stringify(res.data));
                const token = (res?.data?.franchise?.paymentMethods ?? []).find(payment => payment.actionname === 'quentli')?._matchingData?.FranchisePaymentmethods?.value ?? undefined;
                localStorage.setItem('QuentliToken', token);
                user.setUser(res.data);
            }
            submit();
        }
    }, [payload])

    return (
        <div>
            <Loader />
        </div>
    )
}

export default LogSubmit;